import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import usePageTitle from 'hooks/usePageTitle';

import PageMenu from "../../blocks/PageMenu/PageMenu";
import IconArrowGray from "../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "../../../hooks/useDecode";
import FormEditUser from "components/blocks/Forms/FormEditUser";

const ChangeSettings: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  usePageTitle('Cambiar Ajustes');
  const URL_location = location.pathname;
  const [titlePage, setTitlePage] = useState("");
  const [breadCrumbs, setBreadCrumbs] = useState<string[]>([]);
  const tokenResponse = useDecode("token");

  useEffect(() => {
    if (
      URL_location === "/ajustes/cambiar-contraseña" ||
      location.state?.completeUser !== undefined
    ) {
      checkURL();
    } else {
      navigate("/ajustes");
    }
    if (tokenResponse !== undefined) {
      checkURL();
    } else {
      navigate("/inicio");
    }
  }, []);

  const checkURL = () => {
    switch (URL_location) {
      case "/ajustes/cambiar-contraseña":
        setBreadCrumbs(["Ajustes", "Cambiar contraseña"]);
        return setTitlePage("Cambiar contraseña");
      case "/ajustes/editar-usuario":
        setBreadCrumbs(["Ajustes", "Editar usuario"]);
        return setTitlePage("Editar Usuario");
      default:
        return;
    }
  };
  return (
    <>
      <PageMenu title={titlePage} breadcrumbs={breadCrumbs}>
        <div className="btns-header-container">
          <Link to="/ajustes">
            <img src={IconArrowGray} alt="icon arrow right" />
          </Link>
        </div>
      </PageMenu>

      <section>
        {URL_location === "/ajustes/editar-usuario" && (
          <FormEditUser
            completeUser={location.state?.completeUser}
          />
        )}
      </section>
    </>
  );
};

export default ChangeSettings;
